// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoEmbed_videoWrapper__2rheS","videoPlayer":"VideoEmbed_videoPlayer__2EbXL"};